/* eslint-disable */

import React, { useState, useEffect, useCallback, Suspense, useMemo } from "react";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	TextField,
	Button,
	MenuItem,
	Grid,
	Typography,
	Tooltip,
	Chip,
	Paper,
	Box
} from "@mui/material";
import downloadFile from "../../../../../../../utils/commonFunctions/downloadFile";
import shortenFileName from "../../../../../../../utils/commonFunctions/shortenFileName";
import { generateFileURL } from "../../../../../../../utils/commonFunctions/generateFileURL";

import PlanHeader from "../../../../../../shared/enrollment/planCode/PlanHeader";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import "./addPlanDialog.css";
import ApprovalPlanForm from "../../../approvalPlanForm/ApprovalPlanForm";
import { Edit } from "@material-ui/icons";
import EditableBrandingPlain from "./EditableBrandingPage";
export interface PlanDesignFormData {
	status: "ACTIVE" | "INACTIVE" | "DRAFT";
	group_number: number;
	plan_name: string;
	plan_code: string;
	branding_design: {
		logo: File | null;
		image: File | null;
		textual_details: string;
	};
	form_design: {
		textual_details: string;
	};
}

interface PlanDesignFormDialogProps {
	open: boolean;
	onClose: () => void;
	onSubmit: (data: PlanDesignFormData) => void;
	initialData?: PlanDesignFormData;
	mode?: "view" | "edit" | "add";
}

const PlanDesignFormDialog: React.FC<any> = ({ open, onClose, onSubmit, initialData, mode = "add" }) => {
	const [formData, setFormData] = useState<PlanDesignFormData>(
		initialData || {
			status: "ACTIVE",
			group_number: 0,
			plan_name: "",
			plan_code: "",
			branding_design: {
				logo: null,
				image: null,
				textual_details: ""
			},
			form_design: {
				textual_details: ""
			}
		}
	);

	const [imgWidth, setImgWidth] = useState<number>(100);

	const [isView, setIsView] = useState<boolean>(false);

	const handleSubmit = () => {
		onSubmit(formData);
		onClose();
	};

	// Reset form data when dialog opens with new initialData
	useEffect(() => {
		if (initialData) {
			const isView = mode === "view";
			// if (isView || mode === "edit") {
			// 	console.log("initialData in useEffect", initialData);
			// 	setFormData(initialData.planDesign ? initialData.planDesign : initialData);
			// } else {
			setFormData(initialData);
			// }
			setIsView(isView);
		}
	}, [initialData, mode]);

	// (initialBannerSrc = ""), (initialLogoSrc = ""), initialData, (mode = "add"), plan, onClose;

	// open: boolean;
	// onClose: () => void;
	// onSubmit: (data: PlanDesignFormData) => void;
	// initialData?: PlanDesignFormData;
	// mode?: "view" | "edit" | "add";

	return (
		<>
			{isView ? (
				<Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
					{/* <DialogTitle>Your Branding Page</DialogTitle> */}
					<DialogTitle
						sx={{
							textAlign: "center",
							fontWeight: 700,
							color: "#111",
							fontSize: { xs: "1.2rem", sm: "1.4rem" },
							borderBottom: "1px solid #E0E0E0",
							backgroundColor: "#fff",
							boxShadow: "0 4px 14px rgba(0,0,0,0.15)",
							// marginBottom: 3,
							borderRadius: 2,
							width: "100%",
							padding: "10px"
							// marginTop: "10px"
						}}
					>
						Branding & Form Page Preview
					</DialogTitle>

					<DialogContent dividers style={{ minHeight: "650px" }}>
						<Typography
							variant="body1"
							style={{ color: "#666", fontWeight: "bold", textAlign: "center", marginTop: "0px" }}
						>
							Branding Page Design
						</Typography>

						{/* ---------- PLAN DETAILS ---------- */}
						<Box
							sx={{
								backgroundColor: "#FFFFFF",
								borderRadius: "8px",
								padding: "12px 12px",
								display: "flex",
								flexDirection: "column",
								gap: 1,
								// marginTop: 2,

								boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
								width: "100%",
								marginTop: "20px"
								// backgroundColor: "green"
							}}
						>
							<Box
								sx={{
									display: "flex",
									flexDirection: "column",
									alignItems: "start",
									padding: 3,
									minHeight: "12vh",
									// marginTop: 2,
									width: "100%",
									borderRadius: "8px",
									overflow: "hidden",

									// height: { md: "calc(65vh * 0.55)" },
									// minHeight: "40vh",
									position: "relative",
									backgroundColor: "#fff"
								}}
							>
								<PlanHeader planCode={formData?.plan_code} planName={formData?.plan_name} />
							</Box>

							<Box
								sx={{
									display: "flex",
									flexDirection: "column",
									alignItems: "start",
									padding: 3,
									maxHeight: "65vh",
									marginTop: 2,
									width: "100%",
									borderRadius: "8px",
									overflow: "hidden",
									height: { md: "calc(65vh * 0.55)" },
									minHeight: "10vh",
									position: "relative",
									backgroundColor: "#fff"
								}}
							>
								{/* ✅ Logo section — placed at the top inside the main box */}

								<div
									style={{
										width: "120px",
										height: "40px",
										borderRadius: "6px",
										backgroundColor: "#ffff",
										minWidth: "100px",
										maxWidth: "20vw",
										cursor: "pointer",
										overflow: "hidden",
										flexShrink: 0,
										marginLeft: "5px",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										position: "relative" // Needed for skeleton overlay
									}}
									// onClick={(e) => {
									// 	e.stopPropagation();
									// 	logoInputRef.current?.click();
									// }}
								>
									{formData.branding_design.logo ? (
										<img
											src={
												(formData.branding_design.logo as any).originalname
													? generateFileURL(formData.branding_design.logo)
													: URL.createObjectURL(formData.branding_design.logo)
											}
											alt="Logo"
											style={{
												width: "100%",
												height: "100%",
												objectFit: "contain",
												opacity: 1,
												transition: "opacity 0.3s ease",
												zIndex: 1000
											}}
											// stop skeleton when image loaded
										/>
									) : (
										<></>
									)}

									{/* Hidden input */}
									{/* <input
										ref={logoInputRef}
										type="file"
										accept="image/*"
										onChange={handleLogoChange}
										style={{ display: "none" }}
									/> */}
								</div>

								{/* ✅ Banner + Text arranged in a row */}
								<Box
									sx={{
										display: "flex",
										flexDirection: { xs: "column", sm: "column", md: "row" },
										alignItems: "stretch",
										flexShrink: 0,
										justifyContent: "flex-start",
										width: "100%",
										gap: 2
									}}
								>
									{/* ---------- LEFT: Banner ---------- */}
									<div
										style={{
											flex: "1 1 55%",
											minHeight: "150px",
											flexDirection: "column",
											// flex: "0 0 350px",
											position: "relative",
											maxHeight: "60%",
											maxWidth: "350px",
											minWidth: "350px",
											height: "75%",
											overflow: "hidden",
											display: "flex",
											borderRadius: "12px",
											alignItems: "start",
											justifyContent: "start",
											cursor: "pointer",
											backgroundColor: "#FAFAFA",

											boxShadow: `
														  -2px -2px 6px rgba(0,0,0,0.05),
														  8px 0 12px rgba(0,0,0.5,0.45),
														  0 4px 10px rgba(0,0,0,0.05)
														`
										}}
									>
										{formData.branding_design.image ? (
											<>
												<img
													src={
														formData.branding_design.image
															? (formData.branding_design.image as any).originalname
																? generateFileURL(formData.branding_design.image)
																: URL.createObjectURL(formData.branding_design.image)
															: ""
													}
													// alt={`banner-${currentIndex}`}
													style={{
														width: "100%",
														height: "100%",
														objectFit: "cover",
														transition: "transform 0.4s ease",
														boxShadow: "0 4px 14px rgba(0,0,0,35.65)"
													}}
												/>
												<div
													style={{
														position: "absolute",
														top: 0,
														right: 0,
														bottom: 0,
														width: "10%",
														background:
															"linear-gradient(to right, rgba(255,255,255,0) 0%, rgba(255,255,255,0.9) 100%)"
													}}
												/>
											</>
										) : (
											<>
												<div>No Image Uploaded</div>
											</>
										)}
									</div>

									{/* ---------- RIGHT: Text Editor ---------- */}
									{/* <div
										style={{
											flex: "1 1 45%",
											// background: "#FFFFFF",
											padding: "8px 10px",
											display: "flex",
											flexDirection: "column",
											justifyContent: "center",

											maxWidth: "65%",
											maxHeight: "65%"

											// backgroundColor: "green"
										}}
									> */}
									<ReactQuill
										// className="no-border-quill"
										value={formData?.branding_design.textual_details}
										// onChange={(event) => handleBrandingChange(event, "textual_details")}
										// modules={modules}
										// formats={formats}
										// placeholder="enter your text here"
										readOnly={true} // disables editing
										theme="bubble" // 'bubble' theme hides toolbar automatically
										style={{
											width: "90%",
											height: "300px",
											minHeight: "50px",
											maxHeight: "350px",
											border: "none",
											outline: "none",
											boxShadow: "none",
											background: "#FFFFFF",
											fontSize: "15px",
											fontFamily: "inherit",
											lineHeight: 1.5,
											color: "#333",
											overflow: "hidden",
											padding: "4px"
										}}
									/>
									{/* </div> */}
								</Box>
							</Box>
							<Box
								sx={{
									display: "flex",
									justifyContent: { xs: "center", md: "flex-end" },
									alignItems: "flex-end",
									gap: 2,
									mt: 8,
									width: "100%",
									paddingBottom: "20px",
									marginRight: "70px",
									marginTop: "-10px"
								}}
							>
								<Button
									// color="secondary"
									size="small"
									sx={{
										height: "38px",
										width: { xs: "120px", sm: "150px", md: "185px" },
										"&:hover": {
											backgroundColor: "#BDBDBD"
										},
										backgroundColor: "#BDBDBD",
										borderRadius: "6px",
										color: "black"
									}}
								>
									Waive
								</Button>
								<Button
									// variant="contained"
									size="small"
									sx={{
										backgroundColor: "#D0021B",
										color: "white",
										height: "38px",
										width: { xs: "120px", sm: "150px", md: "185px" },
										borderRadius: "6px",
										"&:hover": {
											backgroundColor: "#D0021B" // same as original color, no darkening
										}
									}}
								>
									Enroll
								</Button>
							</Box>
						</Box>

						{/* ---------- BANNER + TEXT SECTION ---------- */}

						<Typography
							variant="body1"
							style={{ color: "#666", fontWeight: "bold", textAlign: "center", marginTop: "30px" }}
						>
							Plan Form Design
						</Typography>

						<ApprovalPlanForm mode="view" plan={formData} />
					</DialogContent>
					<DialogActions>
						<Button onClick={onClose}>Close</Button>
					</DialogActions>
				</Dialog>
			) : (
				<EditableBrandingPlain
					plan={formData}
					onClose={onClose}
					onSubmit={onSubmit}
					initialData={initialData}
					open={open}
					initialBannerSrc={
						(formData?.branding_design.image as any)?.originalname
							? generateFileURL(formData.branding_design.image)
							: ""
					}
					initialLogoSrc={
						(formData?.branding_design.logo as any)?.originalname
							? generateFileURL(formData.branding_design.logo)
							: ""
					}
				/>
			)}
		</>
	);
};

export default PlanDesignFormDialog;
